import { render, staticRenderFns } from "./friendlyLink.vue?vue&type=template&id=75674c65&"
import script from "./friendlyLink.vue?vue&type=script&lang=js&"
export * from "./friendlyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports